import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';
import { RegistrationService } from '../../services/registration.service';
import { PipeModule } from '../../pipes/pipe.module';

@Component({
  selector: 'app-payment-manual-logs-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    PipeModule,
  ],
  templateUrl: './payment-manual-logs-table.component.html',
  styleUrl: './payment-manual-logs-table.component.scss'
})
export class PaymentManualLogsTableComponent implements OnChanges, OnDestroy {
  @Input() registrationPaymentId: number | null = null;
  @Input() logs: any[] | null = null;

  loading = false;
  paymentLogs: any[] = [];
  paymentLogsDataSource = new MatTableDataSource<any>([]);
  columnsToDisplay: string[] = [
    'created_at', 'bank_name', 'bank_account_holder_name', 'bank_account_number',
    'paid_amount', 'payment_date', 'payment_notes', 'status', 'reject_reason', 'payment_slip'
  ];

  private sub?: Subscription;

  constructor(private registService: RegistrationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['logs'] && this.logs) {
      this.paymentLogs = this.logs;
      this.paymentLogsDataSource.data = this.paymentLogs;
      return;
    }

    if (changes['registrationPaymentId'] && this.registrationPaymentId) {
      this.fetchLogs();
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private fetchLogs(): void {
    this.sub?.unsubscribe();
    this.loading = true;
    this.paymentLogs = [];
    this.paymentLogsDataSource.data = [];

    this.sub = this.registService.getRegistrationPaymentManualLogs(this.registrationPaymentId!).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.status) {
          this.paymentLogs = res.data ?? [];
          this.paymentLogsDataSource.data = this.paymentLogs;
        }
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
